import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'gene-chip',
    templateUrl: './chip.component.html',
    styleUrls: ['./chip.component.css'],
    standalone: true
})

/**
 * A reusable “chip” or “pill” component that can act as a toggle or read-only label.
 *
 * @param label                 Text to display inside the chip.
 * @param active                Whether the chip is in its “on” (active) state.
 * @param clickable             If true, clicking toggles the active state; otherwise it's read-only.
 * @param activeColor           CSS color (hex, rgb, etc.) for border and text when active.
 * @param inactiveBorderColor   CSS color for the border when inactive.
 * @param inactiveBgColor       CSS background-color when inactive.
 * @param inactiveTextColor     CSS text color when inactive.
 * @param toggled               Emits the new boolean active value after a click (when clickable).
 */

export class ChipComponent {
    @Input() label = '';
    @Input() active = false;
    @Input() clickable = false;
    @Input() activeColor = '#0071D0';
    @Input() inactiveBorderColor = '#e5e4e4';
    @Input() inactiveBgColor = '#f7f6f6';
    @Input() inactiveTextColor = '#54555d';

    @Output() toggled = new EventEmitter<boolean>();

    get borderColor() {
        return this.active ? this.activeColor : this.inactiveBorderColor;
    }

    get textColor() {
        return this.active ? this.activeColor : this.inactiveTextColor;
    }

    get backgroundColor() {
        return this.active ? 'transparent' : this.inactiveBgColor;
    }

    get hasLabel(): boolean {
        return !!this.label && this.label.trim().length > 0;
    }

    onClick() {
        if (!this.clickable) { return; }

        this.active = !this.active;
        this.toggled.emit(this.active);
    }
}
